import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "shareIos"
const ShareIosIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2 8 5.636h3v8.182h2V5.636h3L12 2Zm6 20H6c-1.11 0-2-.818-2-1.818V9.272c0-.481.21-.944.586-1.285A2.106 2.106 0 0 1 6 7.455h3v1.818H6v10.909h12V9.272h-3V7.456h3c.53 0 1.04.191 1.414.532.375.341.586.804.586 1.286v10.909c0 .482-.21.945-.586 1.286-.375.34-.884.532-1.414.532Z" />
    </svg>
  )
}
export default ShareIosIcon
